import styled from "@emotion/styled";
import { Accordion, AccordionDetails, AccordionSummary, Paper } from "@mui/material";
import StyledSummaryCardLogo from "styles/StyledComponents/StyledSummaryCardLogo";

export const OrderCardWrapper = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "8px",
	marginBottom: "16px"
}));

export const OrderInfo = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "2fr 2fr 2fr 1fr 1fr 1fr",
	padding: "4px 0",
	gap: "24px",
	[theme.breakpoints.down("md")]: {
		display: "flex",
		flexDirection: "column"
	}
}));

export const OrderInfoItemWrapper = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	[theme.breakpoints.down("md")]: {
		flexDirection: "row",
		gap: "8px"
	}
}));

export const OrderInfoItemLabel = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.main
}));

export const OrderInfoItemValue = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));

export const ShippingAndBilling = styled.div(({ theme }) => ({
	gap: "24px",
	display: "flex",
	flexDirection: "row",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const Info = styled.div({
	padding: "16px",
	gap: "8px",
	display: "flex",
	flexDirection: "column",
	border: "1px solid rgba(0, 0, 0, 0.12)",
	flex: 1
});

export const InfoTitle = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle1,
	color: theme.project.colors.fontColors.secondary
}));

export const InfoContent = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "1fr 1fr",
	[theme.breakpoints.down("md")]: {
		display: "flex",
		gap: "16px",
		flexDirection: "column"
	}
}));

export const OrderListLabel = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle1,
	color: theme.project.colors.fontColors.secondary
}));

export const OrderListLineItems = styled.div({
	display: "flex",
	justifyContent: "space-between",
	flexDirection: "row",
	alignItems: "center"
});

export const OrderListLineItemsLabel = styled.div(({ theme }) => ({
	...theme.project.typography.overline,
	color: theme.project.colors.fontColors.main
}));

export const AccountAndBillTo = styled.div(({ theme }) => ({
	gap: "12px",
	display: "flex",
	flexDirection: "row",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const AccountAndBillToInfo = styled.div({
	padding: "16px",
	gap: "8px",
	display: "flex",
	flexDirection: "column",
	border: "1px solid rgba(0, 0, 0, 0.12)",
	flex: 1
});

export const AccountAndBillToInfoContent = styled.div(({ theme }) => ({
	gap: "24px",
	display: "flex",
	justifyContent: "space-between",
	flexDirection: "row",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const DetailsSummaryCardLogo = styled(StyledSummaryCardLogo)(({ theme }) => ({
	height: "40px",
	[theme.breakpoints.down("md")]: {
		alignSelf: "flex-start"
	}
}));

export const ProductDetails = styled.div({
	display: "flex",
	flexDirection: "column"
});

export const ProductDetailsTitle = styled.div(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.project.colors.fontColors.main
}));

export const ProductDetailsSubtitle = styled.div(({ theme }) => ({
	...theme.project.typography.overline,
	color: theme.project.colors.fontColors.secondary
}));

export const EstimatedSubTotal = styled.div({
	display: "flex",
	flexDirection: "row",
	gap: "20px",
	justifyContent: "flex-end"
});

export const EstimatedSubTotalLabel = styled.div(({ theme }) => ({
	...theme.project.typography.alert.alertTitle,
	color: theme.project.colors.fontColors.main
}));

export const EstimatedSubTotalValue = styled.div(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.fontColors.main
}));

export const EstimatedSubTotalBanner = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.allColors.hex.blue.light.lightBlue50,
	display: "flex",
	flexDirection: "row",
	padding: "16px",
	gap: "16px",
	justifyContent: "flex-end"
}));

export const EstimatedSubTotalBannerContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column"
}));

export const EstimatedSubTotalBannerTextContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	gap: "20px",
	[theme.breakpoints.down("md")]: {
		gap: "8px",
		flexDirection: "column"
	}
}));

export const EstimatedSubTotalBannerLabel = styled.div(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.project.colors.primaryColors.main
}));

export const EstimatedSubTotalBannerValue = styled.div(({ theme }) => ({
	...theme.project.typography.heading.h6,
	fontWeight: 400,
	color: theme.project.colors.primaryColors.main
}));

export const EstimatedSubTotalBannerNote = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	fontWeight: 400,
	color: theme.project.colors.primaryColors.main
}));

export const AccordionWrapper = styled(Accordion)(({ theme }) => ({
	boxShadow: "none",
	"&::before": {
		content: "none"
	},
	"& .MuiAccordionDetails-root": {
		display: "flex",
		flexDirection: "column",
		gap: "8px"
	},
	"& .MuiAccordionSummary-root": {
		padding: "0"
	}
}));

export const AccordionSummaryWrapper = styled(AccordionSummary)(({ theme }) => ({
	"& .MuiAccordionSummary-contentGutters": {
		display: "flex",
		justifyContent: "space-between",
		flexDirection: "row"
	}
}));

export const AccordionDetailsWrapper = styled(AccordionDetails)({
	padding: "0"
});
